import { Component } from '@angular/core';
import { PopupModule } from '@progress/kendo-angular-popup';
import { SharedModule } from '@progress/kendo-angular-dropdowns';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import {
  ViewStackSkeletonAccordionComponent,
  ViewStackSkeletonAccordionConfig,
  ViewStackSkeletonElementConfig
} from './view-stack-skeleton-accordion/view-stack-skeleton-accordion.component';

@Component({
  selector: 'bizz-view-stack-skeleton-loader',
  standalone: true,
  imports: [
    PopupModule,
    SharedModule,
    TooltipModule,
    ViewStackSkeletonAccordionComponent
  ],
  templateUrl: './view-stack-skeleton-loader.component.html',
  styleUrl: './view-stack-skeleton-loader.component.scss'
})
export class ViewStackSkeletonLoaderComponent {

  public readonly config: Array<Array<ViewStackSkeletonElementConfig>> = [
    [{ colSpan: 2 },
      { colSpan: 1 },
      { colSpan: 1 },
      {
        colSpan: 4,
        customHeightClass: 'h-40'
      },
      { colSpan: 1 },
      { colSpan: 3 },
      { colSpan: 4 }
    ], [{ colSpan: 2 },
      { colSpan: 1 },
      { colSpan: 1 },
      { colSpan: 3 },
      { colSpan: 1 }],
    []
  ];

  public getAccordionConfig(elements: Array<ViewStackSkeletonElementConfig>): ViewStackSkeletonAccordionConfig {
    return {
      bgElementClass: 'bg-section',
      elements: elements,
      borderClass: 'border-transparent',
      formHeaderBgClass: 'bg-divider-handle/30'
    };
  }
}
